import { createContainer } from "unstated-next";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Zone } from "project-config/constants/user-info";
import request from "project-config/services/request/request";
import { useGlobalStore } from "./GlobalStore";

export interface ISubAccountData {
  coupon: 0.11;
  cloudCoupon: number;
  credit: 0;
  email: string;
  groupTaskLevelView: 1;
  groupTaskLevel: 0;
  hideBalance: 0;
  hideJobCharge: 0;
  id: number;
  inheritMainSoftSet: 0;
  phone: string;
  remark: string;
  qyCoupon: 0.001;
  rmbBalance: 12;
  shareMainCapital: 0;
  status: 1;
  subDeleteCapital: 1;
  subDeleteTask: 0;
  subFullSpeed: 1;
  subPermission: 196;
  subUserName: string;
  totalCredit: null;
  usdBalance: 0;
  useMainBalance: 0;
  userId: null;
  zone: Zone;
  inheritMainConsumptionBillSet: 0;
  inheritMainRenderingJobSet: 0;
  inheritMainRenderingJobSetView: 0;
  isDingTalk?: boolean;
  deptId?: number;
  isSearchSubUser?: boolean;
}
type IAllSubAccountType = {
  userName: string;
  userId: number;
};

function useSubAccountHook() {
  const [subAccountList, setSubAccountList] = useState<ISubAccountData[]>([]);
  const [subUserNameQuery, setSubUserNameQuery] = useState("");
  const [dingTalkAccountList, setDingTalkAccountList] = useState([]);
  const [isMaxSubAccount, setIsMaxSubAccount] = useState(false);
  const [allSubAccountList, setAllSubAccountList] = useState<
    IAllSubAccountType[]
  >([]);
  const [isSearchSubUser, setIsSearchSubUser] = useState(false);
  const { userInfo } = useGlobalStore();

  const { data } = useQuery<ISubAccountData[]>(
    [
      "/api/rendering/user/querySubUserList",
      { userName: subUserNameQuery.trim() },
    ],
    { suspense: false }
  );

  const { data: allSubData } = useQuery<IAllSubAccountType[]>(
    "/api/rendering/task/renderingTask/loadingUserName",
    { suspense: false }
  );

  const fetchSubAccountList = async () => {
    const { data: list } = await request.post<ISubAccountData[]>(
      "/api/rendering/user/querySubUserList",
      { userName: subUserNameQuery.trim() }
    );
    setSubAccountList(list ?? []);
    const { data: fullList } = await request.post<ISubAccountData[]>(
      "/api/rendering/user/querySubUserList"
    );
    setIsMaxSubAccount(userInfo?.subaccountLimits! <= (fullList?.length ?? 0));
  };

  const fetchDingTalkSubAccountList = async (params: {
    deptId?: number;
    subUserId?: number;
  }) => {
    const { data } = await request.post(
      "/api/rendering/user/queryDingTalkSubUserList",
      Object.assign(params, { isShowSubDeptUser: 0 })
    );
    setDingTalkAccountList(data ?? []);
  };

  useEffect(() => {
    if (!data) return;
    setSubAccountList(data);
    if (!subUserNameQuery.trim()) {
      setIsMaxSubAccount(userInfo?.subaccountLimits! <= data.length);
    }
  }, [data, subUserNameQuery, userInfo]);
  useEffect(() => {
    if (!allSubData) return;
    setAllSubAccountList(allSubData);
  }, [allSubData]);

  return {
    subAccountList,
    fetchSubAccountList,
    isMaxSubAccount,
    fetchDingTalkSubAccountList,
    dingTalkAccountList,
    setDingTalkAccountList,
    allSubAccountList,
    isSearchSubUser,
    setIsSearchSubUser,
    setSubUserNameQuery,
  };
}

const GlobalStoreContainer = createContainer(useSubAccountHook);
export const SubAccountStoreProvider = GlobalStoreContainer.Provider;

export function useSubAccountStore() {
  return GlobalStoreContainer.useContainer();
}
